module.exports = __webpack_public_path__ + "img/2.d06d99ec.png";